import { Select } from 'antd';
import { ml } from '../services/utils';
import WebIcon from './WebIconComponent.jsx';

const { Option } = Select;
function FilterByStatus(props) {
	const {
		filteredStatuses,
		handleStatusFilter,
		handleRemoveStatusFilter,
		PendingText,
		IneligibleText,
		EligibleText,
		PaidText,
		currentUser,
		allMultiLingualData,
	} = props;

	const statuses = [
		{
			name: PendingText
				? PendingText
				: ml('Pending', currentUser, allMultiLingualData),
			value: 'pending',
		},
		{
			name: IneligibleText
				? IneligibleText
				: ml('Ineligible', currentUser, allMultiLingualData),
			value: 'ineligible',
		},
		{
			name: EligibleText
				? EligibleText
				: ml('Eligible', currentUser, allMultiLingualData),
			value: 'eligible',
		},
		{
			name: PaidText ? PaidText : ml('Paid', currentUser, allMultiLingualData),
			value: 'paid',
		},
	];

	const statusOptions = statuses.map((status) => {
		return (
			<Option key={status.value} value={status.value}>
				{status.name}
			</Option>
		);
	});

	const handleClick = (style, status) => {
		handleStatusFilter(status);
	};

	const handleRemove = (status) => {
		handleRemoveStatusFilter(status);
	};

	const renderArrowIcon = (count) => {
		return (
			<div>
				<WebIcon color="var(--oslo-gray)" size={10} name="sort-down" />
			</div>
		);
	};

	return (
		<Select
			showArrow
			placeholder={ml(
				`Status`,
				currentUser,
				allMultiLingualData,
				'My Referrals'
			)}
			mode="multiple"
			maxTagCount={1}
			maxTagTextLength={15}
			suffixIcon={renderArrowIcon(filteredStatuses.length)}
			onSelect={(referredKey, { key }) => handleClick(referredKey, key)}
			onDeselect={(referredKey, { key }) => handleRemove(referredKey, key)}
		>
			{statusOptions}
		</Select>
	);
}

export default FilterByStatus;
